// src/pages/portal/PortalLogin.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePortalAuth } from '../../context/PortalAuthContext';

export default function PortalLogin() {
  const { signIn } = usePortalAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function handleLogin() {
    if (!email || !password) {
      setError('Please enter your email and password.');
      return;
    }
    setLoading(true);
    setError('');
    const { error } = await signIn(email, password);
    if (error) {
      setError('Invalid email or password. Please try again.');
    } else {
      navigate('/portal/dashboard');
    }
    setLoading(false);
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter') handleLogin();
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: '#f5f4f0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'Georgia', serif",
      padding: '24px',
    }}>
      {/* Card */}
      <div style={{
        background: '#fff',
        border: '1px solid #e2ddd5',
        borderRadius: '12px',
        padding: '48px 44px',
        width: '100%',
        maxWidth: '400px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
      }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <div style={{
            width: '44px', height: '44px', background: '#1a1a18',
            borderRadius: '8px', display: 'inline-flex',
            alignItems: 'center', justifyContent: 'center',
            marginBottom: '12px',
          }}>
            <span style={{ color: '#c8a96e', fontWeight: '700', fontSize: '16px' }}>TL</span>
          </div>
          <div style={{ fontSize: '20px', fontWeight: '600', color: '#1a1a18', letterSpacing: '-0.01em' }}>
            TLC Unlimited
          </div>
          <div style={{ fontSize: '13px', color: '#888', marginTop: '4px' }}>Client Portal</div>
        </div>

        <div style={{ marginBottom: '20px', fontSize: '14px', color: '#555', textAlign: 'center' }}>
          Sign in to view your estimates and invoices.
        </div>

        {/* Email */}
        <div style={{ marginBottom: '16px' }}>
          <label style={{ display: 'block', fontSize: '12px', color: '#666', marginBottom: '6px', letterSpacing: '0.04em', textTransform: 'uppercase' }}>
            Email
          </label>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="you@example.com"
            style={{
              width: '100%', padding: '10px 12px', boxSizing: 'border-box',
              border: '1px solid #ddd', borderRadius: '7px',
              fontSize: '14px', fontFamily: 'inherit', outline: 'none',
              background: '#fafaf8',
            }}
          />
        </div>

        {/* Password */}
        <div style={{ marginBottom: '24px' }}>
          <label style={{ display: 'block', fontSize: '12px', color: '#666', marginBottom: '6px', letterSpacing: '0.04em', textTransform: 'uppercase' }}>
            Password
          </label>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="••••••••"
            style={{
              width: '100%', padding: '10px 12px', boxSizing: 'border-box',
              border: '1px solid #ddd', borderRadius: '7px',
              fontSize: '14px', fontFamily: 'inherit', outline: 'none',
              background: '#fafaf8',
            }}
          />
        </div>

        {/* Error */}
        {error && (
          <div style={{
            background: '#fff3f3', border: '1px solid #ffc9c9',
            borderRadius: '7px', padding: '10px 14px',
            fontSize: '13px', color: '#c0392b', marginBottom: '16px',
          }}>
            {error}
          </div>
        )}

        {/* Submit */}
        <button
          onClick={handleLogin}
          disabled={loading}
          style={{
            width: '100%', padding: '12px',
            background: loading ? '#888' : '#1a1a18',
            color: '#e8e4d9', border: 'none',
            borderRadius: '7px', fontSize: '14px',
            fontFamily: 'inherit', fontWeight: '600',
            cursor: loading ? 'not-allowed' : 'pointer',
            letterSpacing: '0.02em',
            transition: 'background 0.15s',
          }}
        >
          {loading ? 'Signing in…' : 'Sign In'}
        </button>

        <div style={{ marginTop: '20px', textAlign: 'center', fontSize: '12px', color: '#aaa' }}>
          Don't have access? Contact TLC Unlimited to be set up.
        </div>
      </div>
    </div>
  );
}
